import React from 'react';

import { StyledBottomSection } from '../Styled';

interface IBottomSection {
  children: JSX.Element[];
}

export const BottomSection: React.FC<IBottomSection> = (props): JSX.Element => {
  const { children } = props;

  return <StyledBottomSection>{children}</StyledBottomSection>;
};
